export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-ds-warm">
      <div className="text-center" role="status" aria-live="polite">
        <div className="w-12 h-12 border-4 rounded-full animate-spin mx-auto border-ds-light border-t-ds-accent" aria-hidden="true" />
        <span className="sr-only">Loading…</span>
        <p className="mt-4 text-sm font-semibold tracking-tight text-ds-green" aria-hidden="true">STEP</p>
      </div>
    </div>
  );
}
